<img  *ngIf="type==type" [src]="svgPath" />